var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DownloadOutlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.39446 10.4947C7.40699 10.5107 7.423 10.5237 7.44127 10.5326C7.45954 10.5415 7.4796 10.5461 7.49993 10.5461C7.52026 10.5461 7.54032 10.5415 7.55859 10.5326C7.57686 10.5237 7.59287 10.5107 7.6054 10.4947L9.4804 8.12249C9.54904 8.03544 9.48709 7.90653 9.37493 7.90653H8.13442V2.24135C8.13442 2.16769 8.07415 2.10742 8.00049 2.10742H6.99602C6.92236 2.10742 6.8621 2.16769 6.8621 2.24135V7.90486H5.62493C5.51276 7.90486 5.45082 8.03376 5.51946 8.12082L7.39446 10.4947ZM13.6272 9.90876H12.6227C12.549 9.90876 12.4888 9.96903 12.4888 10.0427V12.6208H2.51109V10.0427C2.51109 9.96903 2.45082 9.90876 2.37716 9.90876H1.3727C1.29904 9.90876 1.23877 9.96903 1.23877 10.0427V13.3574C1.23877 13.6537 1.47817 13.8931 1.77448 13.8931H13.2254C13.5217 13.8931 13.7611 13.6537 13.7611 13.3574V10.0427C13.7611 9.96903 13.7008 9.90876 13.6272 9.90876Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadOutlined);
export default __webpack_public_path__ + "static/media/DownloadOutlined.a71676ab8fa916f9fe97730b84e4589e.svg";
export { ForwardRef as ReactComponent };